export default __webpack_public_path__ + "static/media/PCR_product_X.0be003bb.svg";